<!-- file:///home/henry/Pictures/Screenshot%20from%202018-03-17%2023-26-19.png -->
<template>
<div class="settingsmenu">
  <!-- SLiders -->
  <!-- BUG vertical misposition of icons -->
  <div class="settingsentry settingsslider">
    <v-slider v-model="sound" @click:prepend="mute" prepend-icon="volume_up" always-dirty color="orange darken-4" thumb-color="white"></v-slider>
  </div>
  <div class="settingsentry settingsslider">
    <v-slider v-model="brightness" @click:prepend="fullbright" prepend-icon="brightness_high" always-dirty color="orange darken-4" thumb-color="white" :max="1" :step=".01"></v-slider>
  </div>

  <hr style="border:none;background:#3a3a34;width:50%;">

  <!-- Buttons -->
  <!-- <div @click="toggleFS" class="settingsentry settingsbutton"> -->
    <!-- cant easily update tetx/icon, getState() is asyncron -->
    <!-- <v-icon>fullscreen</v-icon>Fullscreen
  </div> -->

  <!-- <hr style="border:none;background:#3a3a34;width:50%;"> -->

  <!-- Buttons -->
  <v-list dense>
    <v-list-tile @click="toggleFS" class="settingsentry settingsbutton" >
      <v-list-tile-avatar>
        <v-icon>fullscreen</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title>Fullscreen</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>

  <hr style="border:none;background:#3a3a34;width:50%;">


  <!-- Kugeln -->
  <div class="settingskugel">
    <!-- <v-icon>person</v-icon> -->
    <v-icon @click="windowsdialog = true;">compare_arrows</v-icon>
    <!-- <v-icon @click="goLink('http://fakeupdate.net/ubuntu')">refresh</v-icon> -->
    <v-icon @click.stop="shutdowndialog = true;">power_settings_new</v-icon>
  </div>





  <v-dialog v-model="shutdowndialog" persistent transition="fade-transition" max-width="500px">
    <div class="sddialog">
      <table class="systemdialog">
        <tr>
          <td>
            <v-icon color="white" style="font-size: 50px;">power_settings_new</v-icon>
          </td>
          <td style="padding-left:10px;padding-right:20px;">
            <span style="font-size:120%;">{{cb?"Install Updates &amp; ":""}}Power Off</span>
            <br><span style="font-size:90%;">The system <span style="border-bottom:1px dashed grey">would</span> power off automatically in 60 seconds.</span>
            <br><br>
            <v-checkbox dark color="white" :ripple="false" v-model="cb" label="Install pending software updates"></v-checkbox>
          </td>
        </tr>
      </table>
      <br><br><br>
      <div style="width:100%">
        <span class="dialogbutton tripple" @click="shutdowndialog = false;cb = false;">Cancel</span>
        <span class="dialogbutton tripple makebars" @click="restart()">Restart</span>
        <span class="dialogbutton tripple" @click="poweroff()">Power Off</span>
      </div>
    </div>
  </v-dialog>

  <v-dialog v-model="windowsdialog" persistent transition="fade-transition" max-width="500px">
    <div class="sddialog">
      <table class="systemdialog">
        <tr>
          <td>
            <v-icon color="white" style="font-size: 50px;">compare_arrows</v-icon>
          </td>
          <td style="padding-left:10px;padding-right:20px;">
            <span style="font-size:120%;">Switch to Windows</span>
            <br><span style="font-size:90%;">Are you sure? You'll be directed to another webpage</span><br><br>
            <v-checkbox dark color="white" :ripple="false" v-model="cb" label="Install permanently?"></v-checkbox>

          </td>
        </tr>
      </table>
      <br><br>
      <div style="width:100%">
        <span class="dialogbutton double" @click="windowsdialog = false;cb = false;">Cancel</span>
        <span class="dialogbutton double makebars" @click="bootwindows()">{{cb?"Install":"Boot"}} Windows</span>
      </div>
    </div>
    <!-- goLink('https://windows93.net') -->
  </v-dialog>

</div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      sound: 30,
      brightness: 1,
      shutdowndialog: false,
      windowsdialog: false,
      cb: false /*checkbox*/
    }
  },
  methods: {
    mute() {
      this.sound = 0;
    },
    fullbright() {
      this.brightness = 1;
    },
    bootwindows() {
      if (this.cb) {
        this.goLink('http://fakeupdate.net/win10/');
        return;
      }
      this.goLink('https://windows93.net/');
      return;
    },
    restart() {
      if (this.cb) {
        this.goLink('http://fakeupdate.net/ubuntu');
        return;
      }
      // Restart action hier!
      this.shutdowndialog = false;
      this.cb = false;
      this.goLink('https://wuerfeldev.de/');
      return;
    },
    poweroff() {
      if (this.cb) {
        this.goLink('http://fakeupdate.net/ubuntu');
        return;
      }
      // Poweroff action here
      this.shutdowndialog = false;
      this.cb = false;
      this.$emit('bricha',1);
      return;
    },
    goLink(link) {
      this.cb = false;
      window.location.href = link;
      return;
    },
    toggleFS() {
      // console.log(this.$fullscreen.getState());
      this.shutdowndialog = false;
      this.$fullscreen.toggle(document.body, {
        wrap: false
      });

      return;
    }
  },
  watch: {
    'brightness': function(val, oldVal) {
      this.$emit('bricha',(1-val)*0.5);
    }
  }
}
</script>
<style>
/* ganzes Menu */

.settingsmenu {
  padding-top: 10px;
  padding-bottom: 15px;
  width: 300px;
}


/* allgemein */

.settingsentry:not(.settingsbutton) {
  padding-left: 30px;
  padding-right: 30px;
}

.settingsentry>* {
  /* padding: 0px; */
  margin-top: 0px;
  margin-bottom: 0px;
  color: white;
}

.settingsentry:not(.settingskugel):hover,
.settingskugel>*:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* button funktioniert nicht in ff */

.settingsbutton, .settingskugel>* {
    transition: .2s cubic-bezier(.25,.8,.5,1);
}

.settingsentry.settingsbutton:active,
.settingskugel>*:active,
.dialogbutton:active {
  background: #E95420;
}

/* Button[s] */

.settingsbutton {}

.v-list{
  padding:0px;
  background: none !important;
}

.settingsbutton>.material-icons {
  margin-right: 16px;
}

/* Kugeln */

.settingskugel {
  text-align: center;
}

.settingskugel>* {
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 100%;
  border: 1px solid #333;
}

/* sLider */

.settingsslider {
  padding-top: 0px;
  padding-bottom: 0px;
}

.v-input__slot{
  margin: 0px;
}

.v-slider--is-active .v-slider__thumb-container--is-active .v-slider__thumb{
  -webkit-transform: translateY(-50%) scale(.6);
  transform: translateY(-50%) scale(.6);
  /* HACK , .6 is default */
}

.v-messages{
  height:0px;
  display:none;
}


/* Was macht das hier?
.settingsslider .input-group__details,
.checkbox .input-group__details {
  height: 0px;
  display: none;
}



.settingsslider .input-group__prepend-icon {
  font-size: 20px;
  color: white !important;
  padding-left: 0px;
}


.settingsslider .slider {
  margin-left: 16px !important;
}*/


.v-dialog--active {
  /* border: 1px solid black; */
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;

}

.systemdialog {
  padding: 15px;
  padding-bottom: 0px;
  line-height: 1;
}

.sddialog *,
.input-group__icon-cb,
.settingsmenu {
  cursor: default !important;
}

.systemdialog td {
  vertical-align: top;
}


.checkbox label {
  color: white !important;
  font-size: 14px;
}

.dialogbutton {
  float: left;
  background-color: #3f3e39;
  color: white;
  padding: 10px;
  text-align: center;
}

.dialogbutton.tripple {
  width: calc(100% / 3);
}

.dialogbutton.double {
  width: 50%;
}

.dialogbutton.tripple.makebars {
  border-right: 1px solid black;
  border-left: 1px solid black;
}

.dialogbutton.double.makebars {
  border-left: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/partials/Settings.vue